import {GENERATED_FIELD_PREFIX} from '@github-ui/issue-form/utils/default-value'
import {useCallback} from 'react'

import type {DraftIssue} from '../content-preview-types'

export function useOnFieldChangeCallback(
  draftIssue: DraftIssue,
  onChange: (editedIssue: Partial<DraftIssue>, skipVersionBump?: boolean) => void,
) {
  return useCallback(
    (id: string | null | undefined, indexOfFormElement: number | null | undefined, value: string) => {
      const fieldId = id || `${GENERATED_FIELD_PREFIX}-${indexOfFormElement}`

      if (draftIssue.defaultValuesById && draftIssue.defaultValuesById[fieldId] === value) {
        return
      }

      const updatedIssue = {
        ...draftIssue,
        defaultValuesById: {...draftIssue.defaultValuesById},
      }

      updatedIssue.defaultValuesById[fieldId] = value

      onChange(updatedIssue, false)
    },
    [draftIssue, onChange],
  )
}
